/**
 * Viewport fraction at which the dock slot catches the mock: the journey
 * completes while the slot is still mid-screen, so the confetti burst and
 * link-card reveal play in full view as the section settles to the top.
 */
export const DOCK_ARRIVAL_VH = 0.45

/** SendMock phase shown while the mock sits in the hero (files dropped, upload starting). */
export const HERO_PHASE = 0.3

/** SendMock phase on dock arrival (all files sent, link generated — past the 0.92 linkReady gate). */
export const DOCK_PHASE = 0.96

/** Matches the hero collage's grease-pencil tilt; unwinds to 0 during travel. */
export const HERO_TILT_DEG = -2

/** Journey progress at which the mock counts as docked (confetti + link card fire). */
export const DOCK_ON_T = 0.999

/** Progress the user must scroll back above before the celebration re-arms. */
export const DOCK_OFF_T = 0.85
